import React, {useState, useEffect} from 'react';
import Time from '../../Time';
import '../../css/App.css';
import '../../css/bootstrap.min.css';
import bootstrap from 'bootstrap';
import Permissions from '../../Permissions';

class AdminNotificationSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        permissionsList:[]
    }
    this.loadPermissions = this.loadPermissions.bind(this)
  }

  loadPermissions = async() =>{
    let loadedPermissions = await Permissions.getAllPermissions();
    this.setState({permissionsList:loadedPermissions});
    console.log(loadedPermissions);
  }

  updatePermission(e){

  }

  handleFormChange = (e) =>{
    this.setState({[e.target.id]: e.target.value});
  }

  componentDidMount(){
    this.loadPermissions();
  }

  
  render() {
    

    return(
    <div className="col-12 bg-white py-3 mb-3">
        <h2>Notification Options</h2>
        <h6>Notification Interval</h6>
        <div className='row'>
            <form>
                <div className='col-12'>
                    <div className='row'>
                        <div class="col-2 mb-3">
                            <label for="" class="form-label">Minimum</label>
                            <input type="number" defaultValue={1} class="form-control"></input>
                        </div>
                        <div class="col-2 mb-3">
                            <label for="" class="form-label">Maximum</label>
                            <input type="number" defaultValue={15} class="form-control"></input>
                        </div>
                    </div>
                </div>
            </form>
        </div>         
    </div>
    )
  }
}

export default AdminNotificationSettings;